import { GenericLabel } from '@com-delta-idp/mnx-utils';
import {
  CardCarouselBanner,
  BannerImage
} from '../../models/banner.interfaces';

export const BannerImageReserveCardMocks: BannerImage = {
  alt: 'Delta SkyMiles Reserve Card',
  src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/amex-reserve-card.png',
  show: true,
  position: 'right'
};

export const BannerContentReserveCardMocks: GenericLabel = {
  title: 'Delta SkyMiles® Reserve Card Member',
  subtitle: ''
};

export const BannerReserveCardMocks: CardCarouselBanner = {
  labels: BannerContentReserveCardMocks,
  image: BannerImageReserveCardMocks
};
